import Vue from 'vue'
import Router from 'vue-router'
import routes from './routers'
import storage from 'libs/storage'
import wechat from 'libs/wechat'
import api from '@/api'
import store from '@/store'
import {Dialog,Toast} from 'vant'
import utils from 'libs/utils'
Vue.use(Router)
const router = new Router({
    routes,
    mode: 'history'
})
const LOGIN_PAGE_NAME = 'login';
const homeName = 'index';
var checkLogin = (to, token, next,from) => {
    if (to.meta.requiresAuth === true) {
        if (!token && to.name !== LOGIN_PAGE_NAME) {
            store.dispatch("getUserInfo")
                .then(user => {
                    checkLogin(to, user.token, next,from);
                })
                .catch(() => {
                    // console.log(e)
                    // 未登录且要跳转的页面不是登录页 记录跳转地址后 登录成功后回调
                    Dialog.confirm({
                        title: '提示',
                        message: '当前页面需要登录后才可访问,前往登录页面?',
                    }).then(() => {
                        utils.setLastRouter(to)
                        next({
                            name: LOGIN_PAGE_NAME // 跳转到登录页
                        })
                    }).catch(() => {
                        if(from.name===null){
                            next({
                                name: homeName // 跳转到homeName页
                            })
                        }

                    });

                });



        } else {
            // window.history.replaceState(null, null, window.location.href);
            next();
        }

    } else {
        if (token && to.name === LOGIN_PAGE_NAME) {
            // 已登录且要跳转的页面是登录页
            next({
                name: homeName // 跳转到homeName页
            })
        } else {
            next();
        }

    }
}
router.beforeEach((to, from, next) => {
    if (!utils.isWeChat()) {
        console.log(111)
        Toast.fail("请在微信中打开或使用微信扫描二维码")
        return
    }
    if (to.meta.showloading) {
        Toast.loading({
            duration: 0, // 持续展示 toast
            overlay:false,
            forbidClick:true
        });
    }
    
    //appInfo 原始链接
    let token = utils.getToken()
    //记录位置
    if(from.meta.keepAlive){
        const scrollX = window.pageXOffset || window.document.documentElement.scrollLeft || window.document.body.scrollLeft
        const scrollY = window.pageYOffset || window.document.documentElement.scrollTop || window.document.body.scrollTop
        storage.set(from.name+'scroll',{scrollX, scrollY})
    }


    if(to.meta.bgcolor){
        store.commit('setBgColor',to.meta.bgcolor)
    }else{
        store.commit('setBgColor','#fff')
    }

    checkLogin(to, token, next,from);
})

router.afterEach((to) => {
    if (to.meta.title) {
        document.title = to.meta.title;
    }
    if (to.meta.keepAlive) {
        storage.get(to.name+'scroll').then((res)=>{
            setTimeout(()=>{
                window.scrollTo(res.scrollX, res.scrollY)
            },1)
        })

    } else {
        window.scrollTo(0, 0)
    }
    //ios wechat sdk
    if (window.__wxjs_is_wkwebview) {  // IOS
        if (window.entryUrl == '' || window.entryUrl == undefined) {
            var url = `${window.location.origin}${to.fullPath}`
            window.entryUrl = url    // 将后面的参数去除
        }
    }
    if (to.meta.share) share();
    if (to.meta.showloading){
        setTimeout(() => {
            Toast.clear()
        },10e2)
    }

    if (utils.getToken() || to.name != 'login') {
        api.user.getUserInfo().then((res) => {
            if (res.status * 1 === 200) {
                if ((res.data.name == '' || res.data.id_number == '' || typeof(res.data.r_cid)=="undefined" || typeof(res.data.r_sid)=="undefined") && to.name !='UserEdit') {                       
                    Dialog.confirm({
                        title: '提示',
                        message: '请先填写真实姓名及正确的身份证号码及所属街道，否则无法参与活动?',
                    }).then(() => {
                        router.push({name:'UserEdit'})
                    }).catch(() => {
                        router.push({name:'index'})
                    });
                }
            }
        })
    }

})

var share = function () {
    return wechat.updateShareData({
        title: '2023年体锻达标赛',
        description: '2023年体锻达标赛',
        imageUrl:'https://oss.mcloud.moveclub.cn/alphamovecloud/20230718/1689671517/1689671642296/WechatIMG2001.jpg',
        link:`${window.location.protocol}//${ window.location.host}${window.entryUrl}`
    })
}

export default router
